import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_12: DocMigration = {
  maxSchemaVersion: "0.0.12",
  apply(json: any) {
    if (!json.windowCatalog) {
      json.windowCatalog = {};
    }

    for (const windowDescriptorId in json.windowCatalog) {
      const window = json.windowCatalog[windowDescriptorId];

      if (window.excludeMullions) {
        window.mullions = {
          mullionType: "DISABLED",
        };

        delete window.excludeMullions;
      }
    }

    for (const elevationId in json.elevations) {
      const elevation = json.elevations[elevationId];

      elevation.windowCatalog = elevation.windowCatalog ?? {};

      for (const windowDescriptorId in elevation.windowCatalog) {
        const window = elevation.windowCatalog[windowDescriptorId];

        if (window.excludeMullions) {
          window.mullions = {
            mullionType: "DISABLED",
          };

          delete window.excludeMullions;
        }
      }
    }

    for (const roofSystemId in json.roofSystems) {
      const roofSystem = json.roofSystems[roofSystemId];

      if (roofSystem.type === "MULTI_GABLE") {
        for (const roof of roofSystem.subRoofs) {
          if (roof.gableOpenings) {
            if (roof.gableOpenings.headCasing) {
              const target = roof.gableOpenings;
              if (target.headCasing.type === "NONE") {
                target.exteriorCasing = {
                  headCasingType: "NONE",
                };
              } else if (target.headCasing.type === "FROM_PALETTE") {
                target.exteriorCasing = undefined;
              } else if (target.headCasing.type === "INLINE") {
                target.exteriorCasing = {
                  ...target.headCasing.settings,
                };
              }

              delete target.headCasing;
            }
          }
        }
      }
    }

    for (const blockId in json.blocks) {
      const block = json.blocks[blockId];
      for (const layoutId in block.layouts) {
        const layout = block.layouts[layoutId];
        for (const locationId in layout.rooms) {
          const room = layout.rooms[locationId];
          if (!room.layout || !room.layout.openingPatterns) {
            continue;
          }

          for (const openingPattern of room.layout.openingPatterns) {
            for (const opening of openingPattern.openings) {
              if (opening.exteriorHeadCasing) {
                if (opening.exteriorHeadCasing.type === "NONE") {
                  opening.exteriorCasing = {
                    headCasingType: "NONE",
                  };
                } else if (opening.exteriorHeadCasing.type === "FROM_PALETTE") {
                  opening.exteriorCasing = undefined;
                } else if (opening.exteriorHeadCasing.type === "INLINE") {
                  opening.exteriorCasing = {
                    ...opening.exteriorHeadCasing.settings,
                  };
                }

                delete opening.exteriorHeadCasing;
              }
            }
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_12;
